module.exports = __webpack_public_path__ + "img/closed.94efec24.svg";